export type BaseOptionType = {
  id?: IdType
  name?: string
}

type IGetOptionId<Option extends BaseOptionType> = (option?: Option) => IdType

export const areOptionsEqual = <Option extends BaseOptionType>(
  getOptionId: IGetOptionId<Option>,
  currentOption?: Option,
  selectedOption?: Option
) => getOptionId(currentOption) === getOptionId(selectedOption)

export const switchSelectedOptions = <Option extends BaseOptionType>(
  selectedOptions: Option[],
  newSelectedOption: Option,
  getOptionId: (option?: Option) => IdType
): Option[] => {
  const hasInSelectedOptions = selectedOptions.some((option) => areOptionsEqual(getOptionId, option, newSelectedOption))

  return hasInSelectedOptions
    ? selectedOptions.filter((option) => !areOptionsEqual(getOptionId, option, newSelectedOption))
    : [...selectedOptions, newSelectedOption]
}
